export const StockVariant = {
  FERTILIZER: "f",
  CHEMICAL: "c",
  YIELD: "y",
  SEEDLING: "s",
  OTHER: "o",
  DELIVERY: "d",
};
